var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.473,
    height: 18.376,
    viewBox: "0 0 9.473 18.376",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#78849e;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M18.709,7.544a.641.641,0,0,0-.64.64v7.972a3.307,3.307,0,0,1-.9,2.26,3.246,3.246,0,0,1-2.276.972h-.558a3.187,3.187,0,0,1-2.247-1.009,3.292,3.292,0,0,1-.98-2.264V5.83a2.229,2.229,0,0,1,.709-1.62A2.44,2.44,0,0,1,13.5,3.542,2.282,2.282,0,0,1,15.8,5.83v9.6a1.3,1.3,0,0,1-1.189,1.32,1.26,1.26,0,0,1-1.156-1.32V9.955a.64.64,0,0,0-1.279,0v5.479a2.46,2.46,0,0,0,4.187,1.845,2.59,2.59,0,0,0,.718-1.845V5.83a3.584,3.584,0,0,0-3.6-3.58A3.6,3.6,0,0,0,10.934,3.3,3.538,3.538,0,0,0,9.872,5.834V16.119a4.583,4.583,0,0,0,1.337,3.2,4.433,4.433,0,0,0,3.121,1.308h.558A4.479,4.479,0,0,0,18,19.309a4.607,4.607,0,0,0,.98-1.419,4.293,4.293,0,0,0,.365-1.726V8.184A.634.634,0,0,0,18.709,7.544Z",
    transform: "translate(-9.872 -2.25)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachOutline);
export default __webpack_public_path__ + "static/media/attach-outline.55e7421a0801ff208810cc0007e20375.svg";
export { ForwardRef as ReactComponent };